/* eslint-disable no-undef, class-methods-use-this, prefer-destructuring, no-param-reassign */
class ContactForm {
  constructor() {
    this.init();
  }

  init() {
    this.contactFormTabs = document.getElementsByClassName(
      "contact-form__selector-button"
    );
    let formStartEvent = false;
    const contactForms = document.getElementsByClassName("contact-form__form");

    // Remove default active tab
    if (this.contactFormTabs && !window.location.hash.length) {
      Array.prototype.forEach.call(this.contactFormTabs, (tab) => {
        tab.classList.remove("active");
      });
    }

    if (contactForms) {
      this.checkcurrentTabSelector();
      const captchaLoaded = this.loadRecaptcha();
      if (captchaLoaded === true) {
        Array.prototype.forEach.call(contactForms, (contactForm) => {
          const formPrivacyPolicy =
            contactForm.getElementsByClassName("input-form")[0];
          const formSendButton =
            contactForm.getElementsByClassName("contact-button")[0];
          const closeNotificationButton =
            document.getElementById("close-notification");
          if (contactForm) {
            this.newForm(
              contactForm,
              formPrivacyPolicy,
              formSendButton,
              closeNotificationButton
            );

            // Send GTM event
            contactForm.addEventListener("click", () => {
              if (formStartEvent === false && window.dataLayer) {
                dataLayer.push({
                  event: "cta",
                  event_name: "form_start",
                });
                formStartEvent = true;
              }
            });
          }
        });
      }
    }
  }

  removeCurrentActiveClass() {
    Array.prototype.forEach.call(this.contactFormTabs, (tab) => {
      tab.classList.remove("active");
    });
  }

  openForn(formTab, formName) {
    let i;
    const x = document.getElementsByClassName("contact-form__form-container");
    const contactFormContainer = document.getElementsByClassName(
      "contact-form__forms-container"
    );

    // Remove active class from previous active tab
    this.removeCurrentActiveClass();

    // Add current tab active class
    formTab.classList.add("active");

    // Show contact form container
    contactFormContainer[0].style.display = "block";

    // Show current form
    for (i = 0; i < x.length; i += 1) {
      x[i].style.display = "none";
    }
    document.getElementById(formName).style.display = "block";
  }

  checkcurrentTabSelector() {
    const tabSelectors = document.getElementsByClassName(
      "contact-form__selector-button-container"
    );
    let currentTabSelector = tabSelectors[0];
    if (window.location.hash && tabSelectors[0]) {
      const tabHash = window.location.hash;
      const tabId = tabHash.replace("#", "");

      switch (tabHash) {
        case "#start-a-project":
          currentTabSelector = tabSelectors[0];
          break;
        case "#appointment":
          currentTabSelector = tabSelectors[1];
          break;
        case "#career":
          currentTabSelector = tabSelectors[2];
          break;
        default:
          currentTabSelector = tabSelectors[3];
          break;
      }

      const currentTabSelectorChildAnchor =
        currentTabSelector.querySelector("a");

      // Remove default tab selector active class
      if (window.location.hash) {
        this.removeCurrentActiveClass();
      }

      // Add active class to the current tab selector
      currentTabSelectorChildAnchor.classList.add("active");

      // Open the form
      this.openForn(currentTabSelectorChildAnchor, tabId);
    }
  }

  loadRecaptchaScript() {
    if (window.captchaLoaded === false) {
      window.loadJS(
        `https://www.google.com/recaptcha/enterprise.js?render=${googleRecaptchaWebKey}`,
        () => {
          window.captchaLoaded = true;
        }
      );
    }
  }

  loadRecaptcha() {
    // Load Re-captcha V3 or throw an error
    if (typeof googleRecaptchaWebKey !== "undefined" && googleRecaptchaWebKey) {
      const newsletterButton =
        document.getElementsByClassName("newsletter__button")[0];
      const contactFormSections =
        document.getElementsByClassName("js-contact-form");
      const contactForms =
        document.getElementsByClassName("contact-form__form");

      newsletterButton.addEventListener("click", () => {
        this.loadRecaptchaScript();
      });

      if (contactFormSections.length > 0) {
        this.loadRecaptchaScript();
      }

      Array.prototype.forEach.call(this.contactFormTabs, (tab) => {
        tab.addEventListener("click", () => {
          this.loadRecaptchaScript();
        });
      });

      if (contactForms.length > 0 && window.location.hash.length > 0) {
        this.loadRecaptchaScript();
      }

      return true;
    }

    console.error("Set up the Google ReCaptcha V3 keys"); // eslint-disable-line no-console

    return false;
  }

  newForm(
    contactForm,
    formPrivacyPolicy,
    formSendButton,
    closeNotificationButton
  ) {
    const fileInput = document.getElementById("attachment-file");
    const fileSelect = document.getElementsByClassName(
      "form__file-container"
    )[0];

    if (fileSelect !== undefined) {
      fileSelect.onclick = () => {
        fileInput.onchange = () => {
          const filename = fileInput.files[0].name;
          const selectName = document.getElementsByClassName("file-select")[0];
          selectName.innerText = filename;
        };
      };
    }

    // Make sure the privacy policy value is unchecked
    formPrivacyPolicy.checked = false;
    formPrivacyPolicy.value = "unchecked";

    // Listen for privacy policy checkbox changes
    formPrivacyPolicy.addEventListener(
      "change",
      this.privacyPolicyCheckboxToogle
    );

    // Prevent form submit
    contactForm.addEventListener("submit", this.preventFormSubmit);

    // Form validations and submit
    formSendButton.contactForm = contactForm;
    formSendButton.addEventListener("click", this.submitValidateForm);

    // Close notificacion banner
    closeNotificationButton.addEventListener(
      "click",
      this.closeNotificationBanner
    );

    // Enable submit button
    formSendButton.disabled = false;
  }

  privacyPolicyCheckboxToogle(privacyPolicyCheckbox) {
    if (privacyPolicyCheckbox.srcElement.value === "unchecked") {
      privacyPolicyCheckbox.srcElement.value = "checked";
    } else {
      privacyPolicyCheckbox.srcElement.value = "unchecked";
    }
  }

  preventFormSubmit(evt) {
    evt.preventDefault();
  }

  submitValidateForm(evt) {
    const contactForm = evt.currentTarget.contactForm;

    // Get the form parameters
    const action = "contact_form";
    const firstName = contactForm.getElementsByClassName("first_name")[0];
    const email = contactForm.getElementsByClassName("email")[0];
    const phoneNumber = contactForm.getElementsByClassName("phone_number")[0];
    const services = contactForm.getElementsByClassName("services")[0];
    const company = contactForm.getElementsByClassName("company")[0];
    const sectors = contactForm.getElementsByClassName("sectors")[0];
    const locations = contactForm.getElementsByClassName("locations")[0];
    const surface = contactForm.getElementsByClassName("surface")[0];
    const locationsAppointment = contactForm.getElementsByClassName(
      "locations-appointment"
    )[0];
    const file = contactForm.querySelectorAll("[name=attachment_file]")[0];
    const fileMaxSize = contactForm.querySelectorAll("[name=MAX_FILE_SIZE]")[0];
    const fileIsRequired = contactForm.querySelectorAll(
      "[name=file_is_required]"
    )[0];
    const message = contactForm.getElementsByClassName("message")[0];
    const privacyPolicy =
      contactForm.getElementsByClassName("privacy_policy")[0];
    const formType = contactForm.getElementsByClassName("form_type")[0];
    const isNewsletter = contactForm.getElementsByClassName("is_newsletter")[0];
    const newsletterSubscription = contactForm.getElementsByClassName(
      "newsletter_subscription"
    )[0];
    const successMessage =
      contactForm.getElementsByClassName("success_message")[0];
    const errorMessage = contactForm.getElementsByClassName("error_message")[0];
    const notificationsBanner = document.getElementById("notification-banner");
    const notificationMessage =
      document.getElementsByClassName("notification-text")[0];
    const currentLanguage = encodeURI(scriptsAjaxVariables.current_language); // eslint-disable-line
    const defaultLanguage = encodeURI(scriptsAjaxVariables.default_language); // eslint-disable-line
    const formData = new FormData();
    formData.append("action", action);

    function checkFilesSize() {
      if (file.files[0] !== undefined) {
        const size = file.files[0].size;
        if (size <= fileMaxSize.value) {
          return true;
        }
      }
      return false;
    }

    if (firstName) {
      formData.append("first_name", firstName.value);
    }

    if (email) {
      formData.append("email", email.value);
    }

    if (phoneNumber) {
      formData.append("phone_number", phoneNumber.value);
    }

    if (services) {
      formData.append("services", services.value);
    }

    if (company) {
      formData.append("company", company.value);
    }

    if (sectors) {
      formData.append("sectors", sectors.value);
    }

    if (locations) {
      formData.append("locations", locations.value);
    }

    if (surface) {
      formData.append("surface", surface.value);
    }

    if (locationsAppointment) {
      formData.append("locations_appointment", locationsAppointment.value);
    }

    if (fileIsRequired) {
      formData.append("file_is_required", fileIsRequired.value);
      if (file && checkFilesSize(file, fileMaxSize)) {
        formData.append("attachment_file", file.files[0]);
      }
    }

    if (message) {
      formData.append("message", message.value);
    }

    if (privacyPolicy) {
      formData.append("privacy_policy", privacyPolicy.value);
    }

    if (formType) {
      formData.append("form_type", formType.value);
    }

    if (isNewsletter) {
      formData.append("is_newsletter", isNewsletter.value);
    }

    if (newsletterSubscription.checked) {
      formData.append(
        "newsletter_subscription",
        newsletterSubscription.checked
      );
    }

    if (currentLanguage) {
      formData.append("current_language", currentLanguage);
    }

    if (defaultLanguage) {
      formData.append("default_language", defaultLanguage);
    }

    // Disable and animate the submit button
    evt.srcElement.disabled = true;
    evt.srcElement.parentNode.classList.add("validating");

    const handleRecaptchaFailure = (error) => {
      console.error(error); // eslint-disable-line no-console
      notificationMessage.innerHTML = errorMessage.value;
      notificationsBanner.classList.add("active");
      evt.srcElement.disabled = false;
      evt.srcElement.parentNode.classList.remove("validating");
    };

    const recaptchaClient =
      window.grecaptcha && window.grecaptcha.enterprise
        ? window.grecaptcha.enterprise
        : null;

    if (!recaptchaClient) {
      handleRecaptchaFailure(new Error("reCAPTCHA Enterprise not available"));
      return;
    }

    // Recaptcha validation
    recaptchaClient.ready(() => {
      recaptchaClient
        .execute(googleRecaptchaWebKey, { action })
        .then((token) => {
          if (token) {
            formData.append("token", token);
          }

          // Ajax form submit
          const xmlhttp = window.ajaxReq();
          const url = encodeURI(scriptsAjaxVariables.ajax_url); // eslint-disable-line
          xmlhttp.open("POST", url, true); // set true for async, false for sync request
          xmlhttp.send(formData); // or null, if no parameters are passed

          // Validation
          xmlhttp.onreadystatechange = () => {
            if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
              try {
                const data = JSON.parse(xmlhttp.responseText);

                // Hide previous errors
                firstName.classList.remove("show-error");
                email.classList.remove("show-error");
                privacyPolicy.classList.remove("show-error");

                if (phoneNumber) {
                  phoneNumber.classList.remove("show-error");
                }

                if (locations) {
                  locations.classList.remove("show-error");
                }

                if (locationsAppointment) {
                  locationsAppointment.classList.remove("show-error");
                }

                if (file) {
                  file.classList.remove("show-error");
                }

                if (message) {
                  message.classList.remove("show-error");
                }

                if (newsletterSubscription) {
                  newsletterSubscription.classList.remove("show-error");
                }

                if (data.validation === false) {
                  // Show errors
                  if (data.first_name) {
                    firstName.classList.add("show-error");
                  }
                  if (data.email) {
                    email.classList.add("show-error");
                  }
                  if (data.phone_number) {
                    phoneNumber.classList.add("show-error");
                  }
                  if (data.locations) {
                    locations.classList.add("show-error");
                  }
                  if (data.locations_appointment) {
                    locationsAppointment.classList.add("show-error");
                  }
                  if (data.file) {
                    file.classList.add("show-error");
                  }
                  if (data.message) {
                    message.classList.add("show-error");
                  }
                  if (data.privacy_policy) {
                    privacyPolicy.classList.add("show-error");
                  }
                  if (data.newsletter_subscription) {
                    newsletterSubscription.classList.add("show-error");
                  }

                  // Scroll to the first error.
                  const elementsWithError =
                    evt.srcElement.form.getElementsByClassName("show-error");
                  elementsWithError[0].scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });
                } else if (data.success === false) {
                  // Error notification message
                  notificationMessage.innerHTML = errorMessage.value;

                  // Show notification
                  notificationsBanner.classList.add("active");
                } else {
                  // Success notification message
                  notificationMessage.innerHTML = successMessage.value;

                  // Clear the form
                  evt.srcElement.form.reset();

                  // Show notification
                  notificationsBanner.classList.add("active");

                  // Send GTM event
                  if (window.dataLayer && isNewsletter.value === "true") {
                    dataLayer.push({
                      event: "cta",
                      event_name: "join_newsletter",
                    });
                  } else if (window.dataLayer) {
                    dataLayer.push({
                      event: "cta",
                      event_name: "generate_lead",
                      form_type: formType.value,
                    });
                  }
                }

                // Enable and stop the submit button animation
                evt.srcElement.disabled = false;
              } catch (error) {
                // Show notification
                notificationsBanner.classList.add("active");
              }
            }
            evt.srcElement.parentNode.classList.remove("validating");
          };
        })
        .catch(handleRecaptchaFailure);
    });
  }

  closeNotificationBanner(evt) {
    evt.preventDefault();
    evt.srcElement.parentNode.classList.remove("active");
  }
}

export default ContactForm;
